var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column col-12 pb-3"},[_c('vue-editor',{attrs:{"height":"250","placeholder":_vm.$t('job.form.summary.placeholder')},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }